import React, { Component } from 'react'
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './AdminEarnings.css'
import getAllBookingsQuery from './getAllBookings.graphql';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import AdminEarningsList from '../../../components/SiteAdmin/AdminEarnings/AdminEarningsList';
import Loader from '../../../components/Common/Loader/Loader';
//meassage
import {  FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';

export class AdminEarnings extends Component {

    static propTypes = {
        title: PropTypes.string.isRequired
    }

    static defaultProps = {
        bookingDetails: {
            loading: true
        }
    }

    render() {
        const { title, bookingDetails, bookingDetails: { loading } } = this.props;
        
        return (
            <Loader type={"page"} show={loading}>
                <div className={s.root}>
                    <div className={s.container}>
                        <div className={s.heading}><FormattedMessage {...messages.earningsMenu} /></div>
                        <div className={s.paddingRoutesSection}>
                            {
                                !loading && <AdminEarningsList bookingDetails={bookingDetails} />
                            } 
                        </div>
                    </div>
                </div>
            </Loader>
        );
    }
}

export default compose(
    withStyles(s),
    graphql(getAllBookingsQuery, {
        name: 'bookingDetails',
        options: {
            variables: {
                currentPage: 1,
                requestType: 'earnings'
            },
            fetchPolicy: 'network-only'
        }
    })
)(AdminEarnings);
